(function () {
  var rebindTimer = null;
  var retryTimer = null;

  function rebindWayviaWidgets() {
    if (window.PriceSpider && typeof window.PriceSpider.rebind === 'function') {
      window.PriceSpider.rebind();
      return true;
    }

    return false;
  }

  function scheduleRebind() {
    clearTimeout(rebindTimer);
    clearInterval(retryTimer);

    rebindTimer = setTimeout(function () {
      if (rebindWayviaWidgets()) {
        return;
      }

      // PriceSpider loads async; retry briefly until it is available.
      var attempts = 0;
      retryTimer = setInterval(function () {
        attempts += 1;

        if (rebindWayviaWidgets() || attempts > 40) {
          clearInterval(retryTimer);
        }
      }, 100);
    }, 50);
  }

  // Allow other scripts (recommendations, grids, etc.) to request a rebind.
  window.rebindWayviaWidgets = scheduleRebind;

  document.addEventListener('product:variant-change', function (evt) {
    var variant = evt.detail && evt.detail.variant;
    var widgets = document.querySelectorAll('.product__find-more-retailers .ps-widget');

    if (!widgets.length || !variant) {
      return;
    }

    var sku = variant.barcode || variant.sku || '';

    for (var i = 0; i < widgets.length; i++) {
      widgets[i].setAttribute('ps-sku', sku);
    }

    scheduleRebind();
  });

  document.addEventListener('wayvia:rebind', scheduleRebind);
  document.addEventListener('shopify:section:load', scheduleRebind);

  // PLP/search filters and infinite scroll replace product cards via AJAX.
  // Wayvia only binds .ps-widget nodes on first load, so rebind after each update.
  function subscribeToCollectionUpdates() {
    if (typeof window.on !== 'function') {
      return false;
    }

    window.on('collection:updated', scheduleRebind);
    return true;
  }

  function hasUnboundWidgets(node) {
    if (!node || node.nodeType !== 1) {
      return false;
    }

    if (node.matches && node.matches('.ps-widget')) {
      return true;
    }

    return !!(node.querySelector && node.querySelector('.ps-widget'));
  }

  function observeDomForWidgets() {
    if (typeof MutationObserver !== 'function') {
      return;
    }

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var addedNodes = mutations[i].addedNodes;

        for (var j = 0; j < addedNodes.length; j++) {
          if (hasUnboundWidgets(addedNodes[j])) {
            scheduleRebind();
            return;
          }
        }
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  function init() {
    if (!subscribeToCollectionUpdates()) {
      var attempts = 0;
      var timer = setInterval(function () {
        attempts += 1;
        if (subscribeToCollectionUpdates() || attempts > 40) {
          clearInterval(timer);
        }
      }, 50);
    }

    observeDomForWidgets();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
